import { useMemo } from "react"

import { Col, Divider, Flex, Space, Typography } from "antd"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"

import Icon from "../../../../Icon"
import { formatCurrency } from "../../../../Utils/utils"

const { Title, Text } = Typography

const FromAlerts = () => {
  const { t } = useTranslation()
  const commissions = useSelector((state) => state.referrals?.commissions)

  const providers = useMemo(() => {
    return [
      {
        icon: "mastercard",
        iconStyle: { fontSize: 20 },
        name: "Ethoca",
        provider: "ethoca",
        reward: commissions?.ethoca_reward_amount
      },
      {
        icon: "verifi",
        iconStyle: { fontSize: 20 },
        name: "Verifi",
        provider: "verify",
        reward: commissions?.verify_reward_amount
      }
    ]
  }, [commissions])

  return (
    <Flex className="commission-div" vertical flex={1}>
      <Title level={5} style={{ marginBottom: 4 }}>
        {t("From Alerts")}
      </Title>
      <Text type="secondary">
        {t("Commission breakdown. See what you earn from each Alert provider.")}
      </Text>
      <Divider />
      <Col>
        <Space direction="vertical" size={8}>
          {providers.map((provider) => (
            <Flex key={provider.name} gap={12}>
              <Icon type={provider.icon} style={provider?.iconStyle ?? {}} />
              <Text strong>
                {provider.name}
                {" - "}
                {formatCurrency(provider.reward / 100, true)}
              </Text>
            </Flex>
          ))}
        </Space>
        <Flex vertical gap={4} style={{ marginLeft: "32px", marginTop: "8px" }}>
          <Text type="secondary" strong>
            {t("RDR")}
          </Text>
          <Text type="secondary" strong>
            {t("CDRN")}
          </Text>
        </Flex>
      </Col>
      <div className="empty-space" />
      <Flex flex={1} className="note">
        <Space direction="vertical" size={0}>
          <Text strong>
            {t("Note")}
            {t(": On average, 60% of alerts are from Ethoca.")}
          </Text>
          <Text type="secondary" strong>
            {`${t(
              "Example: 1,000 alerts = 600 Ethoca ($1,200) + 400 Verifi ($400)"
            )}. ${t("Total: $1,600 per month plus bonuses")}`}
          </Text>
        </Space>
      </Flex>
    </Flex>
  )
}

export default FromAlerts
